export const fieldTitleStyle = {
  marginBottom: "8px",
  fontSize: "14px",
  fontWeight: 500,
  fontFamily: "Roboto",
};

export const titleStyle = {
  marginBottom: "8px",
  fontSize: "17.38px",
  fontWeight: 600,
  fontFamily: "Montserrat",
  color: "#2E2A40",
  mb: "16px",
  mt: "60px",
};

export const documentLabelStyle = {
  height: "18px",
  my: "8px",
  "& .MuiFormControlLabel-label": {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 500,
    color: "#84818A",
    "&.Mui-disabled ": {
      color: "#B0B0B0",
    },
  },
  display: "flex",
  alignItems: "center",
};

export const radioIconStyle = {
  display: "flex",
  alignItems: "center",
  "& .MuiSvgIcon-root": {
    fontSize: 18,
    color: "#333333",
  },
};

export const selectedImageDiv = {
  border: "1px #767676",
  backgroundColor: "#EFEFEF",
  borderRadius: "2px",
  padding: "10px 16px",
  width: "273px",
  height: "36px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const uploadButtonContainer = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

export const uploadButton = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "92px",
  height: "25px",
  borderRadius: "2px",
  border: "1px solid #767676",
  color: "#171A1F",
  fontFamily: "Roboto",
  fontSize: "14px",
  fontWeight: 400,
  marginRight: "4px",
  backgroundColor: "rgb(239, 239, 239,1)",
  cursor: "pointer",
};

export const checkBox = {
  width: "20px",
  height: "20px",
  borderRadius: "8px",
  border: "1px solid #797B83",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const checkBoxChecked = {
  ...checkBox,
  backgroundColor: "#000000",
  border: "1px solid #ffffff",
};
